import { useMemo } from "react";

const PACKAGE_LABELS = {
  "build-care": "Website Build + Website Care",
  "build-growth": "Website Build + Growth Layer",
};

export default function PaymentSuccess() {
  const params = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const planKey = params.get("plan") || "";
  const packageLabel = useMemo(() => PACKAGE_LABELS[planKey] || "", [planKey]);

  if (packageLabel) {
    return (
      <main className="section" data-testid="payment-success">
        <div className="container-edge legal-container">
          <p className="eyebrow">Package received</p>
          <h1 className="font-display">Your Website Build package has been received.</h1>
          <p>{packageLabel}</p>
          <p>ForgeLayer will follow up with the next steps.</p>
          <a className="btn-primary" href="/#contact">Contact ForgeLayer</a>
        </div>
      </main>
    );
  }

  return (
    <main className="section" data-testid="payment-success">
      <div className="container-edge legal-container">
        <p className="eyebrow">Subscription received</p>
        <h1 className="font-display">Your ForgeLayer subscription was received.</h1>
        <p>
          Thank you. ForgeLayer will follow up with next steps, onboarding details and anything needed to activate your plan.
        </p>
        <a className="btn-primary" href="/#contact">Contact ForgeLayer</a>
      </div>
    </main>
  );
}
